import {type GetterTree} from 'vuex';

const getters: GetterTree<ModuleChatState, RootState> = {
    participantChats(state)
    {
        return state.participantChats;
    },

    strangerChats(state)
    {
        return state.strangerChats;
    },

    allChats(state)
    {
        return ([] as Chat[]).concat(state.strangerChats, state.participantChats);
    },

    isAdmin(state)
    {
        return state.isAdmin;
    },

    totalUnreadMessages(state)
    {
        let count = 0;
        for (const chat of state.participantChats)
        {
            count += chat.new_messages;
        }

        return count;
    },

    tab(state)
    {
        return state.activeTab;
    },

    chat(state): Nullable<Chat>
    {
        return state.activeChat;
    },

    detailsOpen(state): boolean
    {
        return state.detailsOpen && null !== state.activeChat;
    },

    reply(state): Nullable<ChatMessage>
    {
        return state.reply;
    },
};

export default getters;